import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom'
import './Menu.scss';

const propTypes = {
    name: PropTypes.string,
};

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {name} = this.props;
        return (
            <div id="menu" className="col-md-2">
                <div className="menu_section">
                    <div className="profile">
                        <div className="profile_info">
                            <span className='welcome-span'>Welcome</span>
                            <br/>
                            <br/>
                            <h2>{name}</h2>
                        </div>
                    </div>
                    <div id="sidebar-menu" className="main_menu_side hidden-print main_menu active">
                        <ul className="nav side-menu">
                            <li className="current-page">
                                <NavLink to="/admin/dashboard"><i className="ion-ios-home"></i> Home</NavLink>
                            </li>
                            <li>
                                <NavLink to="/admin/profile"><i className="ion-ios-person"></i> Account Settings</NavLink>
                            </li>
                            <li>
                                <NavLink to="/admin/users/all"><i className="ion-ios-people"></i> User Administration</NavLink>
                            </li>
                            <li>
                                <NavLink to="/admin/reports"><i className="ion-document-text"></i>User Reporting</NavLink>
                            </li>
                            <li>
                                <NavLink to="/admin/csms"><i className="ion-ios-people"></i>CSM Management</NavLink>
                            </li>
                            
                        </ul>
                    </div>
                    <div className="sidebar-footer nav side-menu">
                        <li><a href="https://www.noonhome.com/legal/" target="_blank"><i className="ion-ios-information"></i>Legal</a></li>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Templates/Admin/Components/Menu/index.js